// Modal.jsx
import React from 'react';
import { AiOutlineClose } from 'react-icons/ai';

const GeneralModal = ({ open, handleClose, children, width, showCloseButton }) => {
  if (!open) return null;

  const sizes = {
    'xs': '200px',
    'sm': '350px',
    'lg': '650px',
    'xl': '850px',
  }

  const modalWidth = sizes[width]

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={handleClose}
    >
      <div 
        className={`bg-white p-6 rounded-lg relative max-h-[80vh] overflow-y-auto`}
        onClick={e => e.stopPropagation()}
        style={{ width: modalWidth }}
      >
        { showCloseButton ? <button
          className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
          onClick={handleClose}
        >
          <AiOutlineClose size={24} />
        </button> : null}
        {children}
      </div>
    </div>
  );
};

export default GeneralModal;